import { FaTwitter } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiGithub, FiInstagram, FiLinkedin, FiMail, FiTwitter } from "react-icons/fi";
import { MdArrowUpward, MdClose, MdCode, MdEmail, MdLink, MdCameraAlt } from "react-icons/md";

const Footer = () => {

  return (
    <footer
      className="w-full dark:bg-black bg-white relative overflow-hidden lg:px-28 px-4 sm:pt-20 pt-16 lg:pt-24 sm:py-14 py-10 lg:py-16"
    >
      <div className="w-full flex flex-col justify-start items-start">
        <span className="text-xs sm:text-lg md:text-xl lg:text-3xl font-medium uppercase dark:text-zinc-400/70 text-zinc-600/70">Need source code? DM me</span>
        <div className="flex flex-row justify-start pt-1 lg:gap-4 gap-2 items-center w-full">
          <a href="mailto:vivekkhule07@gmail.com" target="_blank" className="flex-1 min-w-0">
            <span className="bg-clip-text text-transparent text-left bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300 dark:to-zinc-50 text-xl sm:text-3xl md:text-4xl lg:text-7xl font-sans md:hover:border-b-8 hover:border-b-2 md:hover:border-b-5 dark:hover:border-zinc-300 hover:border-zinc-900 transition-all duration-300 pt-4 sm:pt-6 relative z-20 font-bold tracking-tight break-words">
              vivekkhule07@gmail.com
            </span>
          </a>
          <span
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="rotate-45 cursor-pointer transition-all duration-500 hover:rotate-0 hover:bg-zinc-600 text-zinc-100 p-2 sm:p-3 lg:p-5 bg-zinc-800 rounded-full flex-shrink-0"
          >
            <MdArrowUpward className="text-base sm:text-xl lg:text-4xl" />
          </span>
        </div>
        <div className="flex w-full md:flex-row flex-col  lg:pt-28 pt-16 sm:pt-20 justify-between md:gap-1 gap-12 items-center">
          <div className="flex flex-row justify-start items-start gap-8 md:gap-8">
            <a href="https://github.com/VKoder" target="_blank">
              <FiGithub className="dark:text-white text-zinc-900 text-2xl md:text-3xl" />
            </a>
            <a href="https://www.linkedin.com/in/vivek-khule-237682250/" target="_blank">
              <FiLinkedin className="dark:text-white text-zinc-900 text-2xl md:text-3xl" />
            </a>
            <a href="https://x.com/VivekKhule" target="_blank">
              <FiTwitter className="dark:text-white text-zinc-900 text-2xl md:text-3xl" />
            </a>
            <a href="https://www.instagram.com/vivekk.dev/" target="_blank">
              <FiInstagram className="dark:text-white text-zinc-900 text-2xl md:text-3xl" />
            </a>
            <a href="mailto:vivekkhule07@gmail.com" target="_blank">
              <FiMail className="dark:text-white text-zinc-900 text-2xl md:text-3xl" />
            </a>


            {/* <a href="" className="text-zinc-50 text-2xl cursor-pointer hover:text-zinc-400 duration-200 transition-all" target="_blank"><Fa className=""/></a> */}
          </div>
          <span className="md:text-lg text-base lg:tracking-wide tracking-wider dark:text-zinc-200 text-zinc-800 font-light">©{new Date().getFullYear()} Vivek Khule, All Rights Reserved</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
